<script lang="ts">
  import type { HeadingElement } from "@shared/types/Heading";
  /**
   * @type {HeadingElement}
   * @default "h1"
   * @description The HTML tag to use for the heading. Defaults to `h1`. Heading tags should follow a logical order, so if you're using multiple headings on a page, you should use `h1` for the most important heading, `h2` for the next most important, and so on. If you're using a heading as a decorative element, you should use `div` or `span` instead. The size of the heading can be controlled with the `class` prop and does not relate to the tag used.
   * @example
   * ```html
   * <Heading tag="h2">Hello World</Heading>
   * ```
   */
  export let tag: HeadingElement = "h1";
  let className: string | undefined | null = undefined;
  export { className as class };

</script>

<!-- prettier-ignore -->
<svelte:element this={tag} class={className} {...$$restProps}>
  <slot />
</svelte:element>
